import type { ColumnDefProps } from '@components/shared/Table/types'
import type { OcNfItemsPurchaseOrdersItemProps } from '../context/types'

interface ParseDetailedSummaryProps {
  data: OcNfItemsPurchaseOrdersItemProps[]
}

export const parseOcNfItemsGrid = ({ data }: ParseDetailedSummaryProps) => {
  if (!data) return []

  const parsedData: ColumnDefProps[][] = data.map((item) => [
    {
      id: 'purchaseOrderNumber',
      columnName: 'Ordem Compra',
      value: item.purchaseOrderNumber || '-',
      align: 'center',
      minWidth: '11rem',
      sortable: true
    },
    {
      id: 'itemSequence',
      columnName: 'Sequência',
      align: 'center',
      value: item.itemSequence || '-',
      minWidth: '9rem',
      sortable: true
    },
    {
      id: 'itemName',
      columnName: 'Descrição do Item',
      align: 'center',
      value: item.itemName || '-',
      minWidth: '10rem',
      sortable: true
    },
    {
      id: 'purchaseOrderItemCount',
      columnName: 'Qtd. Itens OC',
      align: 'center',
      value: item.purchaseOrderItemCount || 0,
      minWidth: '10rem',
      sortable: true
    },
    {
      id: 'purchaseOrderUnitValue',
      columnName: 'Valor Unitário OC (R$)',
      align: 'center',
      currency: true,
      value: item.purchaseOrderUnitValue || '-',
      sortable: true
    },
    {
      id: 'purchaseOrderTotalAmount',
      columnName: 'Valor Total OC (R$)',
      align: 'center',
      currency: true,
      value: item.purchaseOrderTotalAmount || '-',
      minWidth: '10rem',
      sortable: true
    },
    /* {
      id: 'invoiceNumber',
      columnName: 'Dados Nota Fiscal',
      align: 'center',
      value: item.invoiceNumber || '-',
      minWidth: '10rem',
      sortable: true
    }, */
    {
      id: 'invoiceItemCount',
      columnName: 'Qtd. Itens NF',
      align: 'center',
      value: item.invoiceItemCount || '-',
      minWidth: '10rem',
      sortable: true
    },
    /* {
      id: 'invoiceUnitValue',
      columnName: 'Valor Unitário NF (R$)',
      align: 'center',
      value: item.invoiceUnitValue || 0,
      currency: true,
      minWidth: '12rem',
      sortable: true
    }, */
    /* {
      id: 'invoiceTotalAmount',
      columnName: 'Valor Total NF (R$)',
      align: 'center',
      value: item.invoiceTotalAmount || 0,
      currency: true,
      minWidth: '10rem',
      sortable: true
    }, */
    /* {
      id: 'unitPriceDeviation',
      columnName: 'Desvio Vlr Unid. OC x NF',
      align: 'center',
      value: item.unitPriceDeviation || 0,
      currency: true,
      minWidth: '11rem',
      sortable: true
    }, */
    {
      id: 'quantityDeviation',
      columnName: 'Desvio Qtd. OC x NF',
      align: 'center',
      value: item.quantityDeviation || '-',
      minWidth: '11rem',
      sortable: true
    },
    /* {
      id: 'totalPriceDeviation',
      columnName: 'Desvio Valor Total OC X NF',
      align: 'center',
      value: item.totalPriceDeviation || 0,
      currency: true,
      minWidth: '12rem',
      sortable: true
    } */
  ])

  return parsedData
}
